import { z } from 'zod'

// Zod 4 probes `new Function` (when schemas are created) to enable JIT parsing.
// Under our Content-Security-Policy that probe is reported as a violation on
// every page. Our schemas are small, so skip it. Imported first in main.tsx
// so it runs before any module creates a schema.
z.config({ jitless: true })
